export class BusinessGlobalStats {

    nbEvents:number;

    nbFiles:number;

    nbMembers:number;

    nbComments:number;

}

export class BusinessDatedStats {

    pictures: Map<number, number>;

    comments: Map<number, number>;

}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/business-stats.ts